<template>
    <div>
        <div id="main-container" class="container mb-5 pages-inner-container">
            <div class="row justify-content-center">
                <div class="my-5 content-page-container col-12">
                    <div class="main-panel mt-0 px-0 mb-0 pb-2 py-4" >
                        <div class="back-button-container row px-3">
                            <button class="px-0" @click="redirectToDefaultBrowse" >
                                <font-awesome-icon :icon="['fas', 'arrow-left']" />
                                <span class="pl-1">{{ contentPageNavigationText }}</span>
                            </button>
                        </div>
                        <div class="title-container row pt-4 px-3">
                            <h1>{{ contentPageModel.title }}<employee-hub-bookmark :title="contentPageModel.title"/></h1>
                        </div>
                        <div class="d-flex flex-lg-row flex-column mt-2 px-2 py-1 mb-2"></div>
                        <div class="row pt-3">
                            <div class="col-md-12">
                                <div class="rel-container">
                                    <div class="row preview-panel content-pages-panel px-3">
                                        <div class="col-12">
                                            <froalaView v-if="contentPageModel.id" v-model="contentPageModel.content"></froalaView>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>

    </div>
</template>

<script>
    import ContentPageNavMixin from "../mixins/ContentPageNavMixin";


    export default {
        name: "view-content-page",
        mixins: [ContentPageNavMixin],
        components: {

        },
    }

</script>

<style scoped>
    .content-pages-panel >>> .fr-view a {
        color: var(--secondary-color);
    }
    .content-pages-panel >>> .fr-view a:hover {
        color: var(--secondary-color-hover);
        text-decoration: none;
    }

    .content-pages-panel >>> div,
    .content-pages-panel >>> li {
        font-size: 16px;
    }

    .content-page-container {
        border: 1px solid #cccccc;
        padding: 0px 30px 0px 30px;
        border-radius: 4px;
    }

    .loading-container {
        min-height: 90vh;
    }
    .pages-container {
        background: #fff;
    }

    .editPage {
        text-align: right;
    }

    .info-header-bar {
        background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
        background: -webkit-gradient(
                linear,
                left top,
                right top,
                from(#0696d7),
                color-stop(50.93%, #32bcad),
                to(#87bc40)
        );
        background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
    }

    .content-page-container .preview-panel >>> .fr-view p,
    .content-page-container
    .preview-panel
    >>> .fr-view
    li
    .content-page-container
    .preview-panel
    >>> .fr-view
    a,
    .content-page-container .preview-panel >>> .fr-view a {
        color: #0696d7;
    }
    .content-page-container .preview-panel >>> .fr-view a:hover {
        color: var(--secondary-color-hover);
        text-decoration: none;
    }

    @media only screen and (max-width: 768px) {
        .preview-panel >>> .fr-view p {
            position: initial !important;
        }
    }

    .pages-container >>> .section-non-self-service {
        display: none;
    }

    .pages-container >>> p,
    .pages-container >>> span,
    .pages-container >>> div {
        z-index: 20 !important;
    }

    .title-container h1 {
        color: #000000;
        font-size: 38px !important;
        font-family: artifaktElementBold !important;
    }

    .overview-text span {
        font-size: 14px;
        font-weight: bold;
        color: #2f3642;
    }

    .pages-inner-container >>> .bookmark-icon {
        margin-left: 11px !important;
        font-size: 28px  !important;
    }

    .pageTitle {
        margin: 15px 0 25px 0;
        font-size: 26px;
        font-weight: 600;
        color: #185fc4;
        text-align: left;
    }
    .pageDescription {
        color: #185fc4;
    }
    .pages-inner-container {
        padding-right: 30px !important;
        padding-left: 30px !important;
    }
    .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
    }
    .main-panel {
        box-shadow: none !important;
    }
    @media (min-width: 576px) {
        .container {
            max-width: 540px;
        }
    }
    @media (min-width: 768px) {
        .container {
            max-width: 720px;
        }
    }
    @media (min-width: 992px) {
        .container {
            max-width: 960px;
        }
    }
    @media (min-width: 1200px) {
        .container {
            max-width: 1140px;
        }
    }
    .back-button-container button {
        border: 0;
        background: transparent;
        outline: 0;
    }

    .back-button-container svg {
        font-size: 14px;
        color: #000000;
    }

    .back-button-container span:hover {
	color: #000000;
}

    .back-button-container span {
        font-size: 16px;
        color: #000000;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewContentPage.vue